import accountRecoveryService from '@/services/account-recovery.js'

const accountRecoveryHandler = {
  state: {
  },

  mutations: {
  },

  actions: {
    async ACTION_VERIFY_RECOVERY_EMAIL (context, payload) {
      let req = await accountRecoveryService.verifyEmail(payload)
      return Promise.resolve(req)
    },
    async ACTION_VERIFY_RECOVERY_EMAIL_OTP (context, payload) {
      let req = await accountRecoveryService.validateEmailOtp(payload)
      return Promise.resolve(req)
    },
    async ACTION_RECOVERY_ACCOUNT (context, payload) {
      let req = await accountRecoveryService.setPassword(payload)
      return Promise.resolve(req)
    },
    async ACTION_SET_PASSWORD_AFTER_EXPIRY (context, payload) {
      let req = await accountRecoveryService.setPasswordAfterExpired(payload)
      return Promise.resolve(req)
    },
  },

  getters: {
  }
}

export default accountRecoveryHandler
